import { sig, T } from "../lib/design.js";

export function Badge({ label, col }) {
  return (
    <span
      style={{
        fontSize: 10,
        fontWeight: 500,
        padding: "2px 7px",
        borderRadius: 20,
        background: col + "18",
        color: col,
        border: `0.5px solid ${col}44`,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
}

export function ScoreRing({ score, signal }) {
  const col = sig(signal).fg;
  const R = 13;
  const circ = 2 * Math.PI * R;
  return (
    <div style={{ position: "relative", width: 34, height: 34, flexShrink: 0 }}>
      <svg width="34" height="34" viewBox="0 0 34 34">
        <circle cx="17" cy="17" r={R} fill="none" stroke="rgba(0,0,0,0.07)" strokeWidth="2.5" />
        <circle
          cx="17"
          cy="17"
          r={R}
          fill="none"
          stroke={col}
          strokeWidth="2.5"
          strokeDasharray={`${(score / 100) * circ} ${circ}`}
          strokeLinecap="round"
          transform="rotate(-90 17 17)"
        />
      </svg>
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 9,
          fontWeight: 700,
          color: col,
          fontFamily: T.mono,
        }}
      >
        {score}
      </div>
    </div>
  );
}

export function GateDot({ label, active, tip }) {
  return (
    <div
      title={tip}
      style={{
        display: "flex",
        gap: 5,
        alignItems: "center",
        fontSize: 11,
        color: active ? "#22c55e" : T.textMuted,
      }}
    >
      <div
        style={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          flexShrink: 0,
          background: active ? "#22c55e" : "rgba(113,113,122,0.3)",
        }}
      />
      {label}
    </div>
  );
}

export function StatCell({ label, value, col }) {
  return (
    <div style={{ background: "rgba(0,0,0,0.03)", borderRadius: 5, padding: "5px 7px" }}>
      <div
        style={{
          fontSize: 9.5,
          color: T.textMuted,
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          marginBottom: 2,
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: 12,
          fontWeight: 600,
          color: col || T.textPrimary,
          fontFamily: T.mono,
        }}
      >
        {value}
      </div>
    </div>
  );
}
